// Identifiants des thèmes visuels, sans dépendance à Vite : utilisés à la fois par le jeu (config/appTheme.js)
// et par vite.config.js (injection des variables de couleur, manifeste de l'appli).
export const APP_THEMES = Object.freeze(['2027', 'halloween']);
export const DEFAULT_APP_THEME = 'halloween';

/** Couleur de la barre du navigateur et du fond de l'appli installée, par thème. */
export const THEME_COLORS = Object.freeze({ '2027': '#090d24', halloween: '#0d0712' });

/** Ramène une valeur quelconque à un thème connu (le thème par défaut sinon). */
export const resolveAppTheme = (value) => (APP_THEMES.includes(value) ? value : DEFAULT_APP_THEME);
